import React from 'react';
import { Pressable, View } from 'react-native';
import { Link } from 'expo-router';

import { ThemedText } from '@/components/themed-text';

interface LegalFooterProps {
  /** "Ao entrar" no login, "Ao continuar" no cadastro. */
  action: 'entrar' | 'continuar';
}

/**
 * Aviso dos termos preso ao rodapé da tela, fora do formulário.
 *
 * Frase e link são dois textos na mesma linha, com o mesmo tamanho e a mesma
 * altura de linha — aninhar o link dentro do parágrafo desalinhava a base e
 * pedia um empurrão de pixels para disfarçar. `box-none` deixa o toque passar
 * para o que estiver atrás.
 */
export function LegalFooter({ action }: LegalFooterProps) {
  return (
    <View pointerEvents="box-none" className="absolute inset-x-0 bottom-0 items-center px-4 pb-4">
      <View className="flex-row flex-wrap items-center justify-center gap-x-1">
        <ThemedText className="text-center text-[11px] leading-4 text-gray-400">
          Ao {action}, você concorda com os
        </ThemedText>
        <Link href="/privacidade" asChild>
          <Pressable>
            <ThemedText className="text-center font-bold text-[11px] leading-4 text-primary">
              Termos de Uso e Política de Privacidade
            </ThemedText>
          </Pressable>
        </Link>
      </View>
    </View>
  );
}
